<template>

    <div id="topBar">

        <div class="impersonating" v-if="isImpersonating">
            <popover
            tag="div"
                content="Sie befinden sich zur Zeit in der Imitationsansicht. Bitte klicken Sie hier, um die Imitationsansicht wieder zu verlassen"
                trigger="hover">
                <a @click.prevent="deImpersonate">
                    <span class="icon is-small"><i class="fa fa-exchange"></i></span>{{ $t('GLOBAL-IS_IMPERSONATING')
                    }}:</span>
                </a>
            </popover>
        </div>

        <div v-if="userRole != 'Industriepartner'">
            <router-link to="/account">

                <template v-if="userAvatar != null">
                    <div class="avatar lazyImg lazy-img-fadein is-pulled-left" v-lazy:background-image="userAvatar">
                    </div>
                </template>

                <template v-else>
                    <span class="icon is-small"><i class="icon-ak-avatar"></i></span>
                </template>

                {{ fullName }}

            </router-link>
        </div>

        <div>
            <span @click="logout" style="cursor:pointer;">
                <span class="icon is-small"><i class="icon-ak-logout"></i></span>
                <lang labelKey="GLOBAL-LOGOUT"></lang>
            </span>
        </div>
    </div>
 

</template>


<script>
import auth from '../auth';

export default {

    computed: {

        isImpersonating() {

            return this.$store.state.isImpersonating;

        },

        fullName() {

            var username = "";

            if (this.$store.getters.getUser.person != null && this.$store.getters.getUser.person.firstname && this.$store.getters.getUser.person.lastname) {
                username = this.$store.getters.getUser.person.firstname + ' ' + this.$store.getters.getUser.person.lastname;
            } else {
                username = this.$store.getters.getUser.username;
            }

            if (this.$store.getters.getUser.manufacturer != null) {
                return this.$store.getters.getUser.manufacturer.name + ' (' + username + ')';
            }
            else if (this.$store.getters.getUser.site != null) {
                return this.$store.getters.getUser.site.name + ' (' + username + ')';
            }
            else {
                return username;
            }

        },

        userAvatar() {

            if (this.$store.getters.getUser.person != null && this.$store.getters.getUser.person.image != null) {

                return this.$config.assets + this.$store.getters.getUser.person.image.path + '/' + this.$store.getters.getUser.person.image.filename;

            } else {

                return null;

            }

        }

    },

    methods: {

        logout() {
            this.$router.push({ name: 'logout'});
        },

        deImpersonate() {

            var self = this;
            this.axios.get(this.$config.api + 'user/stopImpersonation')
                .then(function (response) {

                    self.$store.commit("userLogIn", response.data.user);
                    self.$store.commit("isImpersonating", false);

                    localStorage.setItem('user', JSON.stringify(response.data.user));
                    localStorage.setItem('isImpersonating', JSON.stringify(false));

                    // redirect
                    self.$router.push(self.$store.getters.getRedirectURL);

                    // notify
                    self.$notify.success({ content: self.$t('MSG-SUCCESS-IMPERSONATING_ENDED') });

                    self.$forceUpdate();

                });

        }

    }
}
</script>

<style scoped>
.avatar {
    width: 18px;
    height: 18px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 50%;
    margin: -3px 7px 0 0;
}
</style>

<style>
.impersonating {
    background: #ffff99;
    transition: all .3s ease !important;
}

.impersonating a {
    color: #333 !important;
}

.impersonating:hover {
    background: #ffff00 !important;
}

.impersonating:hover a {
    color: #000 !important;
}
</style>
